var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './main.scss';
var RevealListItem = function (props) {
    return (_jsxs("li", __assign({ className: "reveal-list-item hsl-second-text flex items-center lg:space-x-2 justify-start lg:py-3 relative" }, { children: [_jsx("span", { className: "z-0 absolute bottom-0 scroll-lock-horizontal-reveal_points-border " + (!props.isLastOne || 'hidden') }, void 0),
            _jsx("strong", __assign({ className: "hsl-number-header block text-enblue" }, { children: props.title }), void 0),
            _jsx("span", __assign({ className: "hsl-number-subheader block text-enblue-900" }, { children: props.description }), void 0)] }), void 0));
};
export default RevealListItem;
